var _style, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNo02(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 794.4 1290",
    style: {
      enableBackground: "new 0 0 794.4 1290"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000050662026817960872790000002728576449954841023_);fill:#C8DC90;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 794.4,
    height: 1290
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000168828529017314696220000017098773948231265939_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000168828529017314696220000017098773948231265939_)",
      fill: "#C8DC90"
    },
    d: "M0,1290 c0-57.1,5.8-110.5,17.3-160.3c11.5-49.8,29.2-97.2,52.8-142.1c23.7-44.9,53.4-89,89.3-132.1c35.8-43.1,77.4-86.5,124.8-130.3 l105.7-98.4c29.2-25.5,52.5-49.2,70.1-71.1c17.6-21.9,31.3-43.7,41-65.6c9.7-21.9,16.1-45.6,19.1-71.1c3-25.5,4.6-54.7,4.6-87.5 c0-106.9-42.5-160.3-127.5-160.3c-32.8,0-58.6,6.7-77.4,20c-18.8,13.4-33.4,31.6-43.7,54.7c-10.3,23.1-17,49.8-20,80.2 c-3,30.4-4.6,62.6-4.6,96.6H0v-49.2C0,253.3,32.2,161,96.6,96.6C160.9,32.2,262.4,0,400.8,0C532,0,629.2,30.4,692.4,91.1 c63.1,60.8,94.7,147.6,94.7,260.6c0,41.3-3.6,79.9-10.9,115.7c-7.3,35.8-18.8,70.1-34.6,102.9c-15.8,32.8-36.4,64.7-61.9,95.7 c-25.5,31-56.5,62.9-92.9,95.7L440.9,896.4c-38.9,35.2-69.2,69.5-91.1,102.9c-21.9,33.4-35.8,62.3-41.9,86.5h486.5V1290H0z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNo02);
export default __webpack_public_path__ + "static/media/no-02.d964a5cd702baf1429e20b8830cad54f.svg";
export { ForwardRef as ReactComponent };